<template>
  <section class="lms-container">
    <div class="content">
    <div class="breadcrumb" style="border: none !important;"></div>

      <div style="padding-bottom:15px;" class="form-actions">
        <button
          :disabled="saving"
          v-on:click="saveCourse"
          type="submit"
          class="btn btn-primary btn-medium"
        >
          <i class="icon-save"></i>&nbsp;Salvar
        </button>
        <a id="save_student_" v-on:click="$router.push({ name: 'courses'})" class="back-button">
          <i class="icon-circle-arrow-left"></i>&nbsp;Voltar
        </a>
      </div>

      <!-- <ul style="margin-top:15px;" class="nav nav-tabs">
        <li class="active"><a href="#">Curso</a></li>
        <li><a href="#">Venda</a></li>
        <li><a href="#">Módulos</a></li>
        <li><a href="#">Aulas</a></li>
      </ul>-->

      <!-- <tabs v-on:tabChanged="changeTab" :names="['Curso','Venda','Módulos','Aulas']" /> -->
      <tabs>
        <tab title="Curso">
          <course-edit ref="courseEditComponent" class="row" :course="course" />
        </tab>
        <tab title="Módulos">
          <module-edit
            v-if="course.id"
            class="row"
            :course="course"
            :modules="modules"
            :teachers="teachers"
            @changed="getModules()"
          />
          <div v-else class="title-section-content" style="padding:0px;">
            <h3>Para cadastrar módulos, salve primeiro as alterações no curso</h3>
          </div>
        </tab>
        <tab title="Certificado">
          <div class="row" v-if="certificate == null">
            <h3 slot="header">Upload do Modelo de certificado</h3>

            <div slot="body">
              <div
                class="modules-content"
                style="overflow-y: scroll;padding-right:0px;padding-left:0px;"
              >
                <div class="module-item">
                  <ul class="lessons-list">
                    <li class="lesson-subtitle custom-grid-modal">
                      <span class="lesson-title">Adicione o arquivo</span>
                    </li>

                    <li class="lesson custom-grid-modal">
                      <div class="large-12 medium-12 small-12 cell">
                        <input type="file" id="files" ref="files" v-on:change="handleFilesUpload()" />
                      </div>
                      <br />
                      <div class="large-12 medium-12 small-12 cell">
                        <button @click="submitFiles()" class="btn btn-success" v-show="!uploading">
                          Carregar para o servidor
                          <i class="fa fa-upload"></i>
                        </button>
                        <span v-show="uploading">Carregando...</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row text-center" style="margin-bottom:15px;">
              <div class="btn-group">
                <button
                  type="button"
                  :disabled="saving"
                  v-on:click="addName"
                  class="btn btn-primary"
                >
                  <i class="icon-save"></i>&nbsp;Adicionar Nome do Aluno
                </button>
                <button
                  type="button"
                  :disabled="saving"
                  v-on:click="addCourseName"
                  class="btn btn-primary"
                >
                  <i class="icon-save"></i>&nbsp;Adicionar Nome do Curso
                </button>
                <button
                  type="button"
                  :disabled="saving"
                  v-on:click="addCpf"
                  class="btn btn-primary"
                >
                  <i class="icon-save"></i>&nbsp;Adicionar Cpf do Aluno
                </button>
                <button
                  type="button"
                  :disabled="saving"
                  v-on:click="addWorkload"
                  class="btn btn-primary"
                >
                  <i class="icon-save"></i>&nbsp;Adicionar Carga Horária
                </button>

                <button
                  type="button"
                  :disabled="saving"
                  v-on:click="addDate"
                  class="btn btn-primary"
                >
                  <i class="icon-save"></i>&nbsp;Adicionar Data Atual
                </button>

              </div>
            </div>

            <div class="row text-center">
              <div class="btn-group">
                <lms-button
                  class="btn-danger"
                  :disabled="saving"
                  v-on:click="removeTemplate"
                  :loading="saving"
                >
                  <i class="fa fa-ban"></i>&nbsp;Remover Certificado
                </lms-button>

                <lms-button
                  class="btn-success"
                  :disabled="saving"
                  v-on:click="saveTemplate"
                  :loading="saving"
                >
                  <i class="fa fa-floppy-o"></i>&nbsp;Salvar Certificado
                </lms-button>

                <!-- <button
                  type="button"
                  :disabled="saving"
                  v-on:click="saveTemplate"
                  class="btn btn-success"
                >
                  <i class="fa fa-floppy-o"></i>&nbsp;Salvar Certificado
                </button>-->
              </div>
            </div>

            <br />
            <div style="margin:auto;">
              <vue-fabric
                crossorigin="Anonymous"
                ref="canvas"
                :width="width"
                :height="height"
                :backgroundImage="backgroundImage"
                v-on:loadedBackground="loaded = true"
                @selection:created="selected"
                @selection:updated="selected"
                @object:moving="moving"
                @createdCanva="loadCertificate"
              ></vue-fabric>
            </div>
          </div>
        </tab>

        <tab title="Avaliações">
          <course-quiz :quizList="quizList" />
        </tab>
        <tab title="Produtos">
          <product-list v-if="course.id"
            class="row"
            :course="course"
            :modules="modules"
            :teachers="teachers"
            @changed="getModules()" />
        </tab>
      </tabs>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import CourseEdit from "./CourseEdit.vue";
import ModuleEdit from "./ModuleEdit";
import CourseQuiz from "./CourseQuiz";
import pdf from "pdfvuer";
import { mapState } from "vuex";
import moment from "moment";
import ProductLinkedList from './ProductLinkedList.vue';
//import SaleEdit from "../Utils/CourseViews/SaleEdit";
//import Tabs from "../Tabs";

axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      course:this.$store.getters.course,
      keyTeste: 0,
      saving: false,
      message: "aaaaaaa",
      variant: "",
      showMessage: false,
      selectedFile: null,
      modules: [],
      teachers: [],
      files: [],
      certificate: null,
      scale: "page-width",
      loaded: false,
      backgroundImage: "",
      width: 1,
      height: 1,
      originalHeight: 0,
      resizePercent: 1,
      uploading: false
    };
  },
  computed: mapState(["quizList"]),
  components: {
    "course-quiz": CourseQuiz,
    "course-edit": CourseEdit,
    "module-edit": ModuleEdit,
    "product-list": ProductLinkedList,
    pdf
    //"sale-edit": SaleEdit
  },
  methods: {
    someMethod() {
      console.log("chamou");
    },
    generate() {
      return;
    },
    addName() {
      console.log("adicionar nome");
      this.$refs.canvas.createTextbox("@nomedoaluno", {id: 'name', top: 10, left: 10 });
console.log(this.$refs.canvas.getObjects())
      setTimeout(() => {
        for (let el in this.$refs.canvas.getObjects()){
          if(this.$refs.canvas.getObjects()[el].id == 'name'){
            
             //this.$refs.canvas.removeCurrentObj( this.$refs.canvas.getObjects()[el])
             this.$refs.canvas.getObjects()[el].removeCurrentObj(); 
             
             console.log(this.$refs.canvas.getObjects())
             
          }
        }
      }, 5000);
      
      
    },
    addCourseName() {
      this.$refs.canvas.createTextbox("@curso", { top: 30, left: 10 });
    },
    addCpf() {
      this.$refs.canvas.createTextbox("@cpf", { top: 50, left: 10 });
    },
    addWorkload(){
      console.log(this.course)
      this.$refs.canvas.createTextbox("@cargahoraria", { top: 70, left: 10 });
    },
    addDate(){
      this.$refs.canvas.createTextbox("@data", { top: 90, left: 10 });
    },
    saveTemplate() {
      let jsonCanva = this.$refs.canvas.toJson();
      let templateConfigs = [];
      this.saving = true;

      //console.log("O json ficou assim: " + JSON.stringify(json));

      // jsonCanva.objects.forEach(element => {
      //   if (element.type == "textbox") {
      //     let item = {
      //       value: element.text,
      //       fontSize: element.fontSize,
      //       fontFamily: element.fontFamily,
      //       color: element.fill,
      //       x: element.left * (this.resizePercent * 10),
      //       y: this.originalHeight - element.top * (this.resizePercent * 10) // é  assim pq o back entende o y começando de baixo pra cima
      //     };
      //     console.log("novo item: " + JSON.stringify(item));
      //     templateConfigs.push(item);
      //   }
      // });

      let apiCall = "/courseCertificate/saveTemplate";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          courseId: this.course.id,
          data: JSON.stringify(jsonCanva)
        })
        .then(res => {
          this.saving = false;
           this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Certificado salvo"
          });
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
           this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao salvar o certificado"
          });
        });
    },
    removeTemplate() {
      let apiCall = "/courseCertificate/remove";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          id: this.course.id
        })
        .then(res => {
          console.log("DELETOU O TEMPLATE");
          this.certificate = null;
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Certificado removido"
          });
        })
        .catch(error => {
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao remover o certificado"
          });
        });
    },
    submitFiles() {
      this.uploading = true;
      let formData = new FormData();
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        formData.append("files[" + i + "]", file);
      }
      formData.append("idCourse", this.course.id);
      const path = this.$global.endpoint + "/upload/upload-certificate";
      axios
        .post(path, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Arquivo carregado com sucesso"
          });
          this.loadCertificate();
          this.uploading = false;
        })
        .catch(error => {
          this.uploading = false;
          console.error(error);
            this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao enviar o arquivo"
          });
        });
    },

    /*
        Handles the uploading of files
      */
    handleFilesUpload() {
      this.files = []; //just 1 file in this case
      let uploadedFiles = this.$refs.files.files;

      /*
          Adds the uploaded file to the files array
        */
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
    },

    /*
        Removes a select file the user has uploaded
      */
    removeFile(key) {
      this.files.splice(key, 1);
    },
    loadCertificate() {
      let vm = this;
      let apiCall = "/courseCertificate/getById";
      const path = this.$global.endpoint + apiCall;
      //this.certificate = null;
      axios
        .post(path, {
          courseId: this.course.id
        })
        .then(res => {
          console.log(res.data);
          this.width = res.data[0].width * this.resizePercent;
          this.height = res.data[0].height * this.resizePercent;
          //this.width = res.data[0].width;
          //this.height = res.data[0].height;
          this.originalHeight = res.data[0].height;
          this.certificate = res.data[0].url;

          let data = res.data[0].data;

          if (data != null) {
            console.log("tem json");
            //this.backgroundImage = res.data[0].url;
            console.log(data);
            this.$refs.canvas.loadFromJSON(JSON.parse(data), () => {});
          } else {
            this.$refs.canvas.setBackgroundImage(res.data[0].url);
            //this.backgroundImage = res.data[0].url;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    saveCourse() {
      this.saving = true;

      if (this.$refs.courseEditComponent != undefined && this.$refs.courseEditComponent.hasErrors()) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Erro",
          text: "Dados não preenchidos"
        });
        this.saving = false;
        return;
      }

      var filename = this.course.image_path;
      if (filename != null) {
        this.course.image_path = filename;
        const path = this.$global.endpoint + "/course/save";
        axios
          .post(path, { course: this.course })
          .then(res => {
            this.course.id = res.data.course.id;
            this.saving = false;
            this.$notify({
              type: "success",
              group: "foo",
              title: "Concluído",
              text: "Dados do curso salvos com sucesso"
            });
          })
          .catch(error => {
            console.error(error);
            this.$notify({
              type: "error",
              group: "foo",
              title: "Erro",
              text: "Erro ao salvar os dados do curso"
            });
            this.saving = false;
          });
      } else {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Erro",
          text: "Banner não escolhido"
        });
        this.saving = false;
      }
    },
    getModules() {
      var self = this;
      const path = this.$global.endpoint + "/module/getall";
      axios
        .post(path, {
          courseId: this.course.id
        })
        .then(res => {
          this.modules = res.data;
          this.loading = false;
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
          this.loading = false;
        });
    },
    getTeachers() {
      const path = this.$global.endpoint + "/teacher/getall";
      axios
        .get(path)
        .then(res => {
          this.teachers = res.data;
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
    handleAdd(url) {
      this.$refs.canvas.createImage(url + "?" + Math.random());
    },
    handleDelete() {
      this.$refs.canvas.removeCurrentObj();
    },
    rotate() {
      this.$refs.canvas.setRotate();
    },
    selected(obj, option) {
      console.log(JSON.stringify(obj));

      this.currentItem = obj.target;

      console.log(JSON.stringify(this.currentItem));
    },
    moving(obj, option) {
      if (obj.target.id == "bg") {
        obj.target.top = this.height / 2;
        obj.target.left = this.width / 2;
      }
    },
    getAllQuiz() {
      this.couponsLoading = true;
      const path = this.$global.endpoint + "/quiz/getall";
      axios
        .post(path, {
          courseId: this.course.id
        })
        .then(res => {
          this.quizList = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  mounted() {
    this.$store.dispatch("loadQuizList", this.course.id);
    //this.getAllQuiz();
    this.getModules();
    this.getTeachers();
    //this.loadCertificate();

    //this.$refs.canvas.createTextbox("Hello!", { top: 100, left: 300 });

    this.loadCertificate();
  },
  created() {
    //this.getModules();
    //this.getTeachers();
  }
};
</script>

<style lang='scss' scoped>
.canvas-container{
  margin: auto !important;
}
.content-wrapper {
  position: relative;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -moz-box;
  display: -webkit-box;
  display: flex;
  -moz-box-flex: 1;
  box-flex: 1;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  .tool-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -moz-box-direction: normal;
    -moz-box-orient: vertical;
    -webkit-flex-direction: column;
    flex-direction: column;
    .pt-iconfont {
      padding: 20px 30px;
    }
  }
  .list-wraper {
    width: 200px;
    border-right: 1px solid #efefef;
    overflow-y: auto;
    flex-shrink: 0;
    box-sizing: border-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -webkit-flex-direction: column;
    flex-direction: column;
    .image-wrapper {
      padding: 20px;
      display: -ms-flexbox;
      display: -moz-box;
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      flex-shrink: 0;
      box-pack: center;
      -webkit--moz-box-pack: center;
      -moz-box-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      box-align: center;
      -moz-box-align: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      border-bottom: 1px solid #efefef;
      position: relative;
      img {
        width: 120px;
      }
      .pt-iconfont {
        position: absolute;
        top: 0px;
        right: 0px;
        font-size: 18px;
        color: #777;
        padding: 10px;
      }
    }
  }
}

.list-wraper {
  width: 200px;
  border-right: 1px solid #efefef;
  overflow-y: auto;
  flex-shrink: 0;
  box-sizing: border-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -moz-box;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -webkit-flex-direction: column;
  flex-direction: column;
  .image-wrapper {
    padding: 20px;
    display: -ms-flexbox;
    display: -moz-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    flex-shrink: 0;
    box-pack: center;
    -webkit--moz-box-pack: center;
    -moz-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    box-align: center;
    -moz-box-align: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    border-bottom: 1px solid #efefef;
    position: relative;
    img {
      width: 120px;
    }
    .pt-iconfont {
      position: absolute;
      top: 0px;
      right: 0px;
      font-size: 18px;
      color: #777;
      padding: 10px;
    }
  }
}

.center-component {
  width: 500px !important;
  height: 500px !important;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}
</style>
